import React from "react";
import { Helmet } from "react-helmet-async";
import "./Art.css";
import nft1 from "../assets/nfts/nft1.jpg";
import nft2 from "../assets/nfts/nft2.jpg";
import nft3 from "../assets/nfts/nft3.jpg";
import nft4 from "../assets/nfts/nft4.jpg";
import nft5 from "../assets/nfts/nft5.jpg";
import nft6 from "../assets/nfts/nft6.jpg";
import nftv1 from "../assets/nfts/nftv1.MP4";
import nftv2 from "../assets/nfts/nftv2.MP4";
import nftv3 from "../assets/nfts/nftv3.MP4";
import nftv4 from "../assets/nfts/nftv4.mp4";
import nftv5 from "../assets/nfts/nftv5.mp4";

//update 
import nft7 from "../assets/nfts/nft7.jpg"
import nftv6 from "../assets/nfts/nftv6.mp4"
import nftv7 from "../assets/nfts/nftv7.mp4"
import nftv8 from "../assets/nfts/nftv8.mp4"
import nftv9 from "../assets/nfts/nftv9.mp4"

import cmsn from "../assets/nfts/comingsoon.webp";

function Art() {
  return (
    <>
      <Helmet>
        <title>Lia | Art</title>
        <meta
          name="description"
          content="Discover the unique art pieces in Lialab NFT Collection."
        />
      </Helmet>
      <div className="art-container">
        <h1 className="art-title">Our <span>Art</span></h1>
        <div className="nft-grid">
          <img className="nft-image" src={nft2} alt="nft2" />
          <video className="nft-video" src={nftv2} autoPlay loop muted playsInline />
          <img className="nft-image" src={nft3} alt="nft3" />
          <video className="nft-video" src={nftv3} autoPlay loop muted playsInline />
          <img className="nft-image" src={nft5} alt="nft5" />
          <video className="nft-video" src={nftv5} autoPlay loop muted playsInline/>
          <img className="nft-image" src={nft6} alt="nft6" />
          <video className="nft-video" src={nftv4} autoPlay loop muted playsInline/>
          <img className="nft-image" src={nft1} alt="nft1" />
          <video className="nft-video" src={nftv1} autoPlay loop muted playsInline />
          <img className="nft-image" src={nft4} alt="nft4" />
          <img className="nft-image" src={nft7} alt="nft7" />
          <video className="nft-video" src={nftv6} autoPlay loop muted playsInline />
          <video className="nft-video" src={nftv7} autoPlay loop muted playsInline />
          <video className="nft-video" src={nftv8} autoPlay loop muted playsInline />
          <video className="nft-video" src={nftv9} autoPlay loop muted playsInline />
          <img className="nft-image" src={cmsn} alt="cmsn" />
        </div>
      </div>
    </>
  );
}

export default Art;